import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import PersonDetail from "./components/PersonDetail/PersonDetail";
import { GenrealInfo, GridRow, PaddingDiv, NoContact } from "./Contacts.styled";

import { Title, FlexRowHeader } from "../../QuoteView.styled";

const PersonInChargeList = (props) => {
  const { t, quoteId, data } = props;

  return (
    <GenrealInfo>
      <FlexRowHeader>
        <Title>{t("QUOTE_SECTION_CONTACTS")}</Title>
      </FlexRowHeader>
      <PaddingDiv>
        {((data && data?.length !== "") || data?.length !== 0) && (
          <GridRow column="1fr 1fr 1fr" marginBottom="20px">
            {data?.map((contact) => {
              return (
                <PersonDetail
                  contactInfo={contact}
                  key={"quote-contact" + contact.id}
                />
              );
            })}
          </GridRow>
        )}
        {(data === null || data?.length === "" || data?.length === 0) && (
          <GridRow column="1fr">
            <NoContact>{t("QUOTE_NO_CONTACTS")}</NoContact>
          </GridRow>
        )}
      </PaddingDiv>
    </GenrealInfo>
  );
};

PersonInChargeList.propTypes = {
  t: PropTypes.func.isRequired,
  quoteId: PropTypes.number.isRequired,
};

export default withTranslation()(PersonInChargeList);
